import { Box, Tooltip } from '@mui/material';
import { LinkItem } from './LinkItem';

/** True when tooltip content is present (empty string is treated as no tooltip). */
export function hasTooltipContent(tooltip: LinkItem['tooltip']): boolean {
  return tooltip != null && tooltip !== '';
}

interface LinkTabLabelProps {
  readonly link: LinkItem;
}

/**
 * Renders tab label content; wraps in Tooltip when `link.tooltip` is set.
 * The label stays inside the Tab so `Tabs` only receives `Tab` children.
 */
export function LinkTabLabel({ link }: LinkTabLabelProps) {
  const inner = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        minWidth: '6ch',
        justifyContent: 'center',
      }}
    >
      {link.icon} {link.text}
    </Box>
  );

  if (!hasTooltipContent(link.tooltip)) {
    return inner;
  }

  return (
    <Tooltip title={link.tooltip} placement="top">
      <Box component="span" sx={{ display: 'inline-flex', maxWidth: '100%' }}>
        {inner}
      </Box>
    </Tooltip>
  );
}
